import React from 'react';
import { IconButton, Menu, MenuItem, Tooltip, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { SaveRounded } from '@material-ui/icons';
import { useStaffExport, ExportFormat } from '../hooks/useStaffExport';
import { StaffDailyHours } from '../utils/staffDailyHours';

const useStyles = makeStyles(() => ({
  exportButton: {
    color: '#FFFFFF',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: 8,
    padding: 8,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  exportButtonLoading: {
    color: '#FFFFFF',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: 8,
    padding: 8,
  },
  exportMenu: {
    '& .MuiPaper-root': {
      backgroundColor: '#020B26',
      color: '#FFFFFF',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
  },
  exportMenuItem: {
    fontSize: 14,
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
}));

interface StaffExportButtonProps {
  startDate: string;
  endDate: string;
  dailyHours?: StaffDailyHours | null;
  hospitalTimezone?: string;
  disabled?: boolean;
}

const StaffExportButton: React.FC<StaffExportButtonProps> = ({
  startDate,
  endDate,
  dailyHours = null,
  hospitalTimezone,
  disabled = false,
}) => {
  const classes = useStyles();
  const { exportLoading, exportMenuAnchor, handleExportClick, handleExportClose, handleExport } = useStaffExport();

  const onExport = (format: ExportFormat) => {
    handleExport(format, startDate, endDate, { dailyHours, hospitalTimezone });
  };

  return (
    <>
      <Tooltip
        title={dailyHours ? 'Export Staff Location History for Applied Daily Hours' : 'Export Staff Location History'}
      >
        <IconButton
          className={exportLoading ? classes.exportButtonLoading : classes.exportButton}
          onClick={handleExportClick}
          disabled={exportLoading || disabled}
        >
          {exportLoading ? <CircularProgress size={20} color="inherit" /> : <SaveRounded />}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={exportMenuAnchor}
        open={Boolean(exportMenuAnchor)}
        onClose={handleExportClose}
        className={classes.exportMenu}
      >
        <MenuItem className={classes.exportMenuItem} onClick={() => onExport('csv')}>
          Export as CSV
        </MenuItem>
        <MenuItem className={classes.exportMenuItem} onClick={() => onExport('xlsx')}>
          Export as XLSX
        </MenuItem>
      </Menu>
    </>
  );
};

export default StaffExportButton;
